import React from 'react';
import times from 'lodash/times';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { HtmlTable } from '../CommonComponents/OPL/HtmlTable/HtmlTable';

const ROWS_COUNT = 10;
const COLUMNS_COUNT = 6;

export const CampaignsLoading = () => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="24">
        <Shimmer width={130} height={32} />
        <Shimmer width={150} height={36} />
      </Box>
      <HtmlTable>
        <table style={{ tableLayout: 'fixed' }}>
          <colgroup>
            <col width="32%" />
            <col width="10%" />
            <col width="12%" />
            <col width="16%" />
            <col width="14%" />
            <col width="15%" />
          </colgroup>

          <thead>
            <tr>
              {times(COLUMNS_COUNT).map(key => (
                <th key={key}>&nbsp;</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {times(ROWS_COUNT).map(key => (
              <tr key={key}>
                {times(COLUMNS_COUNT).map(cellKey => (
                  <td key={cellKey}>
                    <Shimmer width="100%" height={24} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </HtmlTable>
    </>
  );
};
